import { getFormattedDate } from 'utils/formatters';
import { USER_PHOTO_PLACEHOLDER_LINK } from 'consts';
import { NextBackgroundImage, NextIcon } from 'components/NextImage';
import { NextLink } from 'components/NextLink';

import styles from './ReviewItem.module.scss';

export type ReviewItemProps = {
  from: boolean;
  author: string;
  username: string;
  text: string;
  rate: number;
  date: number;
  itemPhoto: string;
  itemSlug: string;
};

const rateOptions = [0, 1, 2, 3, 4];

export const ReviewItem = ({ author, from, username, text, rate, date, itemPhoto, itemSlug }: ReviewItemProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <NextLink href={`/users/${username}`} useDirectLink={true}>
          <NextBackgroundImage customClass={styles.avatar} src={author || USER_PHOTO_PLACEHOLDER_LINK} />
        </NextLink>
        <div className={styles.details}>
          <div className={styles.detailsHeading}>
            <p className={styles.username}>
              {from ? 'From: @' : 'To: @'}
              <NextLink href={`/users/${username}`} useDirectLink={true}>
                <p>{username}</p>
              </NextLink>
            </p>
            <p>{getFormattedDate(date, 'MON DD, YYYY')}</p>
          </div>
          <div className={styles.detailsReview}>
            <p>{text}</p>
          </div>
          <div className={styles.detailsRate}>
            <p>Rate:</p>
            {rateOptions.map((option) => (
              <NextIcon
                key={option}
                src={option < rate ? '/icons/StarBlue.svg' : '/icons/StarLightBlue.svg'}
                size={16}
              />
            ))}
          </div>
        </div>
        <NextLink href={`/gear/${itemSlug}`}>
          <NextBackgroundImage customClass={styles.product} src={itemPhoto} />
        </NextLink>
      </div>
      <div className={styles.mobileContent}>
        <div className={styles.detailsReview}>
          <p>{text}</p>
        </div>
        <div className={styles.detailsRate}>
          <p>Rate:</p>
          {rateOptions.map((option) => (
            <NextIcon
              key={option}
              src={option <= rate ? '/icons/StarBlue.svg' : '/icons/StarLightBlue.svg'}
              size={16}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
